import styled, { css } from 'styled-components'

import {
    FullWidthHeight,
    FlexCentered,
    FlexJustifyContentCenter,
} from 'components/common/genericStyles'
import { Color } from 'constants/color'
import { hexToRgba } from 'helpers/miscellaneous'

const gradientColor = hexToRgba(Color.unknownColor20, 0.7)

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    ${props =>
        props.isStaticGesture
            ? css`
                  ${FlexJustifyContentCenter}
                  align-items: flex-end;
              `
            : FlexCentered};

    background: ${props =>
        props.isStaticGesture
            ? `linear-gradient(180deg, ${hexToRgba(
                  Color.unknownColor24,
                  0
              )} 0%, ${hexToRgba(Color.unknownColor26, 0.8)} 71.87%)`
            : `linear-gradient(0deg, ${gradientColor}, ${gradientColor})`};

    & > div.lf-player-container {
        width: inherit;
        height: inherit;
    }
`
